import { EndEstado } from '../endereco/endEstado';
import { Padrao } from '../generic/padrao';
import { Pessoa } from '../pessoa/pessoa';

export class Veiculo extends Padrao{

    override idTab = 274;

    endEstado: EndEstado | null = new EndEstado();
    pessoa: Pessoa | null = new Pessoa();
    veiculo: Veiculo | null = null;
    tipoTransp: string;
    tipoTracao: string;
    tipoCarroc: string;
    descricao: string;
    placa: string;
    renavan: string;
    tara: number;
    capKg: number;
    capM: number;
    antt: string;

}

